import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
const mixin = {
  mixins: [validationMixin],
  validations: {
    activeFieldGrammar: { 
      value: {
        ja: {required}
      }
     },
  },
  computed: {
    activeFieldGrammarErrors() {
      const errors = [];
      if (!this.$v.activeFieldGrammar.value.ja.$dirty) return errors;
      !this.$v.activeFieldGrammar.value.ja.required &&
        errors.push("日本語を入力してください。");
      return errors;
    },
  },
};

export default mixin;
